(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/replace', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/replace'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.replace, global.convert);
    global.replace = mod.exports;
  }
})(this, function (exports, _replace2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.replace = undefined;

  var _replace3 = _interopRequireDefault(_replace2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces matches for pattern in string with replacement.
   * @function
   * @memberof string
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {RegExp|string} pattern The pattern to replace.
   * @param {Function|string} replacement The match replacement.
   * @return {Object} Returns the updated object.
   * @example replace({ nested: { a: "Hi Nico" } }, 'nested.a', 'Nico', 'Yvo') // => { nested: { a: "Hi Yvo" } }
   * @see {@link https://lodash.com/docs#replace|lodash.replace} for more information.
   * @since 0.3.0
   */
  var replace = (0, _convert.convert)(_replace3.default);
  exports.replace = replace;
  exports.default = replace;
});